<template>
  <div>
    <b-row class="mt-4">
      <b-col md="4" class="my-1">
        <b-form-group class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Search"></b-form-input>
            <b-input-group-append>
              <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="2" class="my-1" align="right">
        <b-form-group label-cols-sm="6" label="Show" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="3" class="my-1"></b-col>
      <b-col md="3" class="my-1" align="right">
        <b-button variant="primary" @click="showModalFormUniversalVoucher('create', '')">
          <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
        </b-button>
      </b-col>
    </b-row>
    <br />
    <!-- <section v-if="table_error">
      <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
    </section> -->
    <b-table
      responsive
      show-empty
      hover
      ref="universalVoucherTable"
      :items="getDataUniversalVoucher"
      :fields="types"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      head-variant="light"
      class="bg-white"
      :tbody-tr-class="addExpiredClass"
      :tbody-tr-attr="addExpiredTitle"
    >
      <div slot="table-busy" class="text-center text-primary my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
      <template v-slot:cell(voucher_name)="{ item }">
        <p class="mb-0">{{item.voucher_name}}</p>
      </template>
      <template v-slot:cell(membership)="{ item }">
        <b-row>
          <b-col md="2">
            <span v-if="item.membership.includes('gold')" style="display:flex;align-items: center;"><i class="fas fa-check text-success"></i>&nbsp;Gold</span>
            <span v-else style="display:flex;align-items: center;"><i class="fas fa-times text-danger"></i>&nbsp;Gold</span>
          </b-col>
          <b-col md="2">
            <span v-if="item.membership.includes('silver')" style="display:flex;align-items: center;"><i class="fas fa-check text-success"></i>&nbsp;Silver</span>
            <span v-else style="display:flex;align-items: center;"><i class="fas fa-times text-danger"></i>&nbsp;Silver</span>
          </b-col>
          <b-col md="2">
            <span v-if="item.membership.includes('gold2.0')" style="display:flex;align-items: center;"><i class="fas fa-check text-success"></i>&nbsp;Gold2.0</span>
            <span v-else style="display:flex;align-items: center;"><i class="fas fa-times text-danger"></i>&nbsp;Gold2.0</span>
          </b-col>
          <b-col md="2">
            <span v-if="item.membership.includes('silver2.0')" style="display:flex;align-items: center;"><i class="fas fa-check text-success"></i>&nbsp;Silver2.0</span>
            <span v-else style="display:flex;align-items: center;"><i class="fas fa-times text-danger"></i>&nbsp;Silver2.0</span>
          </b-col>
          <b-col md="2">
            <span v-if="item.membership.includes('non_member')" style="display:flex;align-items: center;"><i class="fas fa-check text-success"></i>&nbsp;Non Member</span>
            <span v-else style="display:flex;align-items: center;"><i class="fas fa-times text-danger"></i>&nbsp;Non Member</span>
          </b-col>
        </b-row>
      </template>
      <template v-slot:cell(expiry_date)="{ item }">
        <b-row>
          <p class="mb-0" v-if="item.expiry_date">{{ item.expiry_date | DateTimeV4 }}</p>
          <p class="mb-0" v-else>-</p>
        </b-row>
      </template>
      <template v-slot:cell(action)="{item}">
        <b-row>
          <b-link v-b-tooltip.hover title="Edit" class="text-dark" @click="showModalFormUniversalVoucher('edit', item.id)">
            <img src="@/assets/ic-edit.svg" class="mr-2" alt />
          </b-link>
          <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="deleteUniversalVoucher(item.id, item.voucher_name)">
            <img src="@/assets/rectangle.svg" class="mr-2" alt />
          </b-link>
        </b-row>
      </template>
    </b-table>
    <b-row class="mx-auto">
      <b-col md="4" align="left" class="mx-auto px-0">
        <div v-if="totalRows == 0 || totalRows == null">
          Showing 0 Records
        </div>
        <div v-else>
          Showing {{ fromPage[currentPage - 1] }} to
          {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
        </div>
      </b-col>
      <b-col md="4" class="mx-auto"></b-col>
      <b-col md="4" align="right" class="px-0">
        <b-pagination
          align="right"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <b-modal
      v-model="modalFormVoucherUniversalShow"
      size="l"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop>
      <div class="container">
        <b-row>
          <b-col>
            <h2 class="font-weight-bold">Create Voucher</h2>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Voucher Name"
              label-for="input-1"
              style="font-size: 12px"
            >
              <input
                v-model="universal_voucher.voucher_name"
                v-validate="'required'"
                name="voucher_name"
                data-vv-as="Voucher Name"
                id="voucher_name"
                class="form-control"
                placeholder="Voucher Name"
              />
            <b-form-invalid-feedback id="input-voucher_name-feedback">{{
              veeErrors.first("voucher_name")
            }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
              <b-form-group
                id="fieldset-1"
                label="Expiry Date"
                label-for="input-1"
                class="form-group font-weight-bold"
              >
                <b-row class="m-0">

                &nbsp;
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="is_unlimited"
                  name="checkbox-1"
                  value="1"
                  unchecked-value="0"
                  label-class="control-label"
                  class="font-weight-bold"
                  size="lg"
                >
                  Unlimited
                </b-form-checkbox>
                </b-row>
                <b-row class="m-0 pt-2" v-show="!expired_date_disabled">
                  <b-col
                    class="
                  pr-0
                  pt-1
                  form-control
                  img-calender-select
                  border-right-0
                "
                    md="2"
                  >
                    <img
                      src="@/assets/ic-calendar-copy-30.svg"
                      width="20px"
                      alt
                      class
                    />
                  </b-col>
                  <b-col class="px-0">
                    <vc-date-picker
                      v-model="expired_date"
                      :min-date="new Date()"
                      mode="dateTime"
                      color="purple"
                      is24hr
                    >
                      <template v-slot="{ inputEvents }">
                        <input
                          class="
                            form-control
                            text-dark
                            pl-0
                            bg-white
                            calender-select
                          "
                          v-model="formatted_expired_date"
                          v-validate="'required'"
                          :disabled="expired_date_disabled"
                          name="date"
                          data-vv-as="Expiry Date"
                          autocomplete="off"
                          readonly="true"
                          v-on="inputEvents"
                        />
                      </template>
                    </vc-date-picker>
                    <p style="width:100%;margin-top:.25rem;font-size: 80%;color: #e74a3b;font-weight: bold;margin-left: -35px;">{{ veeErrors.first('date') }}</p>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="
                    pt-1
                    px-4
                    form-control
                    del-calender-select
                    border-left-0
                  "
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link
                            @click="resetExpiredDate"
                            style="text-decoration: none"
                          >
                            <i class="text-danger fas fa-eraser"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
              </b-form-group>
          </b-col>
          <b-col sm="6">
            
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Membership"
              label-for="input-1"
              style="font-size: 12px"
            >
              <b-form-checkbox-group
                v-model="universal_voucher.membership"
                data-vv-as="Membership"
                v-validate="'required'"
                name="membership"
                id="membership"
                stacked
              >
                <b-form-checkbox
                  v-for="member in universal_voucher_membership"
                  :key="member.value"
                  :value="member.value"
                >{{member.text}}</b-form-checkbox>
              </b-form-checkbox-group>
              <p style="width:100%;margin-top:.25rem;font-size: 80%;color: #e74a3b;">{{ veeErrors.first('membership') }}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        

        <b-row>
          <b-col>
            <b-button
              variant="light"
              :disabled="loading_form_universal_voucher"
              @click="modalFormVoucherUniversalShow = !modalFormVoucherUniversalShow"
              class="text-primary"
              block
              size="lg"
              >Close</b-button
            >
          </b-col>
          <b-col>
            <b-button
              v-if="universal_voucher.id != ''"
              variant="primary"
              :disabled="loading_form_universal_voucher"
              @click="editUniversalVoucher()"
              block
              size="lg"
            >
              <b-spinner v-if="loading_form_universal_voucher" small label="Loading..."></b-spinner>
              <span v-else>Save & Run</span>
            </b-button>
            <b-button
            v-else
              variant="primary"
              :disabled="loading_form_universal_voucher"
              @click="createUniversalVoucher()"
              block
              size="lg"
            >
              <b-spinner v-if="loading_form_universal_voucher" small label="Loading..."></b-spinner>
              <span v-else>Save & Run</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      table_error: false,
      loading_universal_voucher: false,
      loading_form_universal_voucher: false,
      modalFormVoucherUniversalShow: false,
      universal_voucher: {
        id: "",
        voucher_name: "",
        membership: [],
      },
      universal_vouchers: [],
      types: [
        {
          key: "voucher_name",
          label: "Voucher Name",
          sortable: false,
          class: "text-left w-10 hg-expired"
        },
        {
          key: "membership",
          label: "Membership",
          sortable: false,
          class: "text-left w-50"
        },
        {
          key: "expiry_date",
          label: "Expiry Date",
          sortable: false,
          class: "text-left w-10 hg-expired"
        },
        { key: "action", label: "Action", class: "text-left w-10" }
      ],
      fromPage: [],
      toPage: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
      // universal_voucher_name: "",
      // universal_voucher_membership_selected: [],
      universal_voucher_membership: [
        {text: "Gold", value: "gold"},
        {text: "Silver", value: "silver"},
        {text: "Gold2.0", value: "gold2.0"},
        {text: "Silver2.0", value: "silver2.0"},
        {text: "Non Member", value: "non_member"},
      ],
      now:"", //current date time to compare for voucher expiry date
      expired_date:"", // model var datepicker to store datepicker value
      formatted_expired_date:"", // value date from date picker with custom format for display purpose
      is_unlimited:"0", // checkbox voucher is set unlimited or limited
      expired_date_validation:"required", // validation toogle for expiry date on crud
      expired_date_disabled:false, // toogle show/hide date picker for expiry date
    }
  },
  watch :{
    //toogle show hide and reset value when user check/uncheck checkbox is unlimited on modal crud universal voucher
    is_unlimited(newVal, oldVal) {
      if(newVal == 1){
        this.expired_date = ""
        this.expired_date_validation = ""
        this.expired_date_disabled = true
      }else{
        this.expired_date_validation = "required"
        this.expired_date_disabled = false
      }
    },
    // to reformat selected date for display purpose
    expired_date(newVal){
      if(newVal){
        this.formatted_expired_date = moment(newVal).format('DD/MM/YYYY HH:mm') //display purpose
        this.universal_voucher.expiry_date =  moment.utc(newVal).format('YYYY-MM-DDTHH:mm')  //for payload purpose
      }else{
        this.universal_voucher.expiry_date = "" //for payload purpose
        this.formatted_expired_date = "" //display purpose
      }
    },
  },
  mounted(){
    setInterval(() => {
      //change current date time so check expiry logic is ongoing every second
      this.now = moment()
    }, 1000); // second checks
  },
  methods: {
    getDataUniversalVoucher(ctx, callback) {
      this.loading_universal_voucher = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("app_name", process.env.VUE_APP_NAME_UA);
      formData.append("is_sort_asc", false);
      this.$store
        .dispatch("VoucherModule/getUniversalVouchersWithPaging", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.universal_vouchers = response.data.data.results || [];
          this.now = moment()
          callback(response.data.data.results || []);
          this.loading_universal_voucher = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response ? error.response.data.message : "Failed get universal voucher",
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading_universal_voucher = false;
          callback([]);
        });
      return null;
    },
    showModalFormUniversalVoucher(action, id) {
      this.universal_voucher = {
        id: "",
        voucher_name: "",
        expiry_date: "",
        membership: [],
      };
      this.expired_date = ""
      this.is_unlimited = "0";
      this.formatted_expired_date = ""
      if (action == 'edit') {
        this.$store
        .dispatch("VoucherModule/getUniversalVoucher", id)
        .then(response => {
          this.universal_voucher = response.data.data;
          if(response.data.data.expiry_date){
            //convert response expiry date to custom format for display purpose
            this.formatted_expired_date = moment(this.universal_voucher.expiry_date).format('DD/MM/YYYY HH:mm')
            //convert type date for selected date in date picker
            this.expired_date = moment.utc(this.universal_voucher.expiry_date).local().format();
          }else{
            //check checkbox unlimited
            this.is_unlimited = 1;
            this.universal_voucher.expiry_date = "";
          }
        })
        .catch(error => {
          console.log(error);
        });
      }
      this.modalFormVoucherUniversalShow = !this.modalFormVoucherUniversalShow;
    },
    createUniversalVoucher() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading_form_universal_voucher = true;
          const formData = new FormData();
          formData.append("voucher_name", this.universal_voucher.voucher_name);
          formData.append("expiry_date", this.universal_voucher.expiry_date);
          formData.append("app_name", process.env.VUE_APP_NAME_UA);
          formData.append("membership", this.universal_voucher.membership);
          this.$store
            .dispatch("VoucherModule/postUniversalVoucher", formData)
            .then((response) => {
              this.loading_form_universal_voucher = false;
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.modalFormVoucherUniversalShow = false;
              this.$refs.universalVoucherTable.refresh();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.data : "Failed store universal voucher",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.loading_form_universal_voucher = false;
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    editUniversalVoucher() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading_form_universal_voucher = true;
          const formData = new FormData();
          formData.append("voucher_name", this.universal_voucher.voucher_name);
          formData.append("membership", this.universal_voucher.membership);
          formData.append("expiry_date", this.universal_voucher.expiry_date);
          this.$store
            .dispatch("VoucherModule/putUniversalVoucher", {
              id: this.universal_voucher.id,
              formData
            })
            .then((response) => {
              this.loading_form_universal_voucher = false;
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.modalFormVoucherUniversalShow = false;
              this.$refs.universalVoucherTable.refresh();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.data : "Failed store universal voucher",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.loading_form_universal_voucher = false;
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    deleteUniversalVoucher(id, voucherName) {
      var payload = {
        app_name:process.env.VUE_APP_NAME_UA,
        voucher_id:id
      }
      this.$swal({
        text: `Are you sure want to delete ${voucherName}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6051a2",
        cancelButtonColor: "#f8f9fc",
        cancelButtonClass: "text-primary",
        confirmButtonText: "Delete",
        scrollbarPadding: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("VoucherModule/deleteUniversalVoucher", payload)
            .then((response) => {
              this.$swal("Deleted!", "Your data has been deleted.", "success");
              console.log(response);
              this.$refs.universalVoucherTable.refresh();
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.message : "Failed to delete",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
            });
        }
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    cxFilter(payload) {
      this.cx_type = payload;
      this.$refs.cxContent.refresh();
    },
    cxDate() {
      if (this.date_to < this.date_from) {
        this.$swal({
          title: "Tanggal tidak sesuai!",
          type: "error",
          showConfirmButton: false,
          timer: 1000,
        });
      } else {
        this.$refs.cxContent.refresh();
      }
    },
    resetExpiredDate() {
      this.expired_date = "";
      this.$refs.cxContent.refresh();
    },
    //add custom class on expired voucher row
    addExpiredClass(item, type) {
      if (item && type === 'row') {
        if(item.expiry_date == null){
          return ''
        }else if (moment(item.expiry_date) < this.now) {
          return ' expired bg-expired'
        } else {
          return ''
        }
      }else {
        return null
      }
    },
    // add custom title on expired voucher row
    addExpiredTitle(item, type) {
      if (item && type === 'row') {
        if(item.expiry_date == null){
          return ''
        }else if (moment(item.expiry_date) < this.now) {
          let obj = {
            "title" : 'Voucher is expired'
          }
          return obj
        } else {
          return null
        }
      } else {
        return null
      }
    }
  }
};
</script>

<style>
.expired{
  color: #b4b6c6 !important;
}
.expired .hg-expired{
  color: #fb8787 !important;
}
.bg-expired{
  background-color: #F9F9FC !important;
}
.expired:hover{
  color: #b4b6c6 !important;
  background-color:#F9F9FC !important;
}
.big-checkbox {width: 30px; height: 30px;}
</style>